import React, { useState, useEffect } from "react"

// import "./ripplebutton.styles.scss"

const RippleButton = props => {
  const [coords, setCoords] = useState({ x: -1, y: -1 })
  const [isRippling, setIsRippling] = useState(false)

  useEffect(() => {
    if (coords.x !== -1 && coords.y !== -1) {
      setIsRippling(true)
      setTimeout(() => setIsRippling(false), 300)
    } else setIsRippling(false)
  }, [coords])

  useEffect(() => {
    if (!isRippling) setCoords({ x: -1, y: -1 })
  }, [isRippling])

  return (
    <div
      className="ripple-button"
      onClick={e => {
        const rect = e.target.getBoundingClientRect()
        setCoords({ x: e.clientX - rect.left, y: e.clientY - rect.top })
        // onClick && onClick(e)
      }}
    >
      {isRippling ? (
        <span
          className="ripple"
          style={{
            left: coords.x,
            top: coords.y,
          }}
        />
      ) : (
        ""
      )}
      {props.children}
    </div>
  )
}

export default RippleButton

//   ReactDOM.render(
//     <RippleButton onClick={e => console.log(e)}>Click me</RippleButton>,
//     document.getElementById('root')
//   );
